import React, { useEffect } from "react";
import { skills } from "./Constants";
import Reveal from "./Reveal";
import { motion, useAnimation, useInView } from "framer-motion";
import { useRef } from "react";

const SkillBar = ({ stat }) => {
  const skillsProgressBarRef = useRef(null);
  const controls = useAnimation();
  const inView = useInView(skillsProgressBarRef, { once: true, amount: 0.3 });

  useEffect(() => {
    if (inView) {
      controls.start({
        width: `${stat.width}%`,
        transition: { duration: 1.5, ease: "easeOut" },
      });
    }
  }, [controls, inView, stat.width]);

  return (
    <React.Fragment>
      <div className="gridStatusTitleContainer !text-[#9857D3]">
        <div className="gridSkillsTitle text-gray-500">{stat.label}</div>
        {stat.icon}
      </div>

      <div
        ref={skillsProgressBarRef}
        className="skillsStatusBarContainer !bg-[#11071F]"
      >
        <motion.div
          className="h-full !bg-[#9857D3]"
          initial={{ width: "0%" }}
          animate={controls}
        />
        <motion.span
          className="skillsStatusPercentage text-[#CCD6F6] sm:text-[18px] text-[15px]"
          initial={{ opacity: 0 }}
          animate={{ opacity: inView ? 1 : 0 }}
          transition={{ delay: 0.3 }}
        >
          {stat.width}%
        </motion.span>
      </div>
    </React.Fragment>
  );
};

const Skills = () => {
  const skillEntries = Object.entries(skills);

  return (
    <div id="skills" className="w-full">
      <div className="flex flex-col justify-center w-full h-full max-w-screen-lg p-4 pt-20 mx-auto text-white">
        <div className="fadein">
          <Reveal slidePermission={false}>
            <p className="inline p-2 text-4xl font-bold text-white border-b-4 border-gray-500">
              Skills
            </p>
          </Reveal>
          <Reveal slidePermission={false}>
            <p className="py-1 px-2 text-gray-500">
              These are the technologies I've worked with
            </p>
          </Reveal>
        </div>

        {/* Skills Grid */}
        <div className="skillsContainer mt-12">
          <div className="grid grid-cols-1 gap-8 px-0 md:px-4 md:grid-cols-2 lg:grid-cols-2 !z-40">
            {skillEntries.map((skill, index) => (
              <Reveal slidePermission={false} key={index}>
                <div className="skillGridCard dark:!bg-[#404040] bg-gradient-to-br from-[#100924] via-[#140a23] to-[#160530] fadein p-[16px] rounded-lg ">
                  <Reveal slidePermission={false}>
                    <div className="skillsGridTitle text-[#CCD6F6]">
                      {skill[0]}
                    </div>
                  </Reveal>

                  <div className="gridItemStatsContainer">
                    {skill[1].map((stat) => (
                      <SkillBar key={stat.id} stat={stat} />
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
